import { createContext, useContext } from 'react';
import { routes } from '../../config';

interface UnmanagedRouteContextValue {
  basePath: string;
}

export const UnmanagedRouteContext = createContext<UnmanagedRouteContextValue | null>(null);

export function useUnmanagedRoute() {
  const context = useContext(UnmanagedRouteContext);

  if (context === null) {
    throw new Error('useUnmanagedRoute must be used within a UnmanagedRouteContextProvider');
  }

  return context;
}

interface UnmanagedRouteContextProviderProps {
  slug: string;
  children: React.ReactNode;
}

export function UnmanagedRouteContextProvider({ slug, children }: UnmanagedRouteContextProviderProps) {
  return (
    <UnmanagedRouteContext.Provider value={{ basePath: `${routes.unmanaged.base}/${slug}` }}>
      {children}
    </UnmanagedRouteContext.Provider>
  );
}
